import { createRootRoute, Outlet } from "@tanstack/react-router";

/**
 * Root of the TanStack route tree.
 *
 * Deliberately bare: the app's provider stack still lives in App.jsx, outside
 * the RouterProvider, exactly where it sat when react-router was mounted here.
 * Keeping it there makes the seam a local change rather than a re-parenting of
 * every context in the app.
 */
export const Route = createRootRoute({
  component: () => <Outlet />,
});
